import { render, staticRenderFns } from "./ImprovePrices.vue?vue&type=template&id=5310f86f&scoped=true"
import script from "./ImprovePrices.vue?vue&type=script&lang=js"
export * from "./ImprovePrices.vue?vue&type=script&lang=js"
import style0 from "./ImprovePrices.vue?vue&type=style&index=0&id=5310f86f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5310f86f",
  null
  
)

export default component.exports